// Polyfill for Intl.DisplayNames (start) https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/DisplayNames
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-displaynames/polyfill';
import '@formatjs/intl-displaynames/locale-data/nl-BE';
import '@formatjs/intl-displaynames/locale-data/da';
import '@formatjs/intl-displaynames/locale-data/de';
import '@formatjs/intl-displaynames/locale-data/en';
import '@formatjs/intl-displaynames/locale-data/es';
import '@formatjs/intl-displaynames/locale-data/fi';
import '@formatjs/intl-displaynames/locale-data/fr';
import '@formatjs/intl-displaynames/locale-data/it';
import '@formatjs/intl-displaynames/locale-data/nb';
import '@formatjs/intl-displaynames/locale-data/nl';
import '@formatjs/intl-displaynames/locale-data/pl';
import '@formatjs/intl-displaynames/locale-data/pt';
import '@formatjs/intl-displaynames/locale-data/sv';
import '@formatjs/intl-displaynames/locale-data/tr';
// Polyfill for Intl.DisplayNames (end)
import { getLanguage } from '@libs/focus-frontend-services/src/PreferencesService/PreferencesService';
import memoize from 'lodash.memoize';

export enum MaintainedLanguage {
  DutchBelgium = 'nl-BE',
  English = 'en-GB',
  FrenchBelgium = 'fr-BE',
  FrenchFrance = 'fr-FR',
  German = 'de-DE',
  GermanSwitzerland = 'de-CH',
  Spanish = 'es-ES',
  Italian = 'it-IT',
  DutchNetherlands = 'nl-NL',
}

export const getLanguageWithDevFallback = (): MaintainedLanguage => {
  const language = getLanguage();
  return language === 'tlh-KL' ? MaintainedLanguage.English : language;
};

export const getLanguageName = memoize((languageCode) => {
  // We are using our language map as primary "translator", since our language keys are not ISO correct for all languages
  const languageNameTL = window.__INITIAL_STATE__.global.languages[languageCode.toUpperCase()]?.value;
  return languageNameTL || new Intl.DisplayNames(getLanguageWithDevFallback(), { type: 'language' }).of(languageCode);
});

export const getCountryName = memoize((countryCode) =>
  new Intl.DisplayNames(getLanguageWithDevFallback(), { type: 'region' }).of(countryCode),
);

export const parseLanguage = memoize((language) => language.split('-')[0].toLowerCase());

export const getUserLanguage = memoize(() => {
  const userLanguageFromISO = parseLanguage(getLanguageWithDevFallback());
  return userLanguageFromISO === 'tlh' ? 'en' : userLanguageFromISO;
});

export const translatedLanguages: Record<MaintainedLanguage, string> = {
  [MaintainedLanguage.DutchBelgium]: 'form:fields.language.nl-BE',
  [MaintainedLanguage.English]: 'form:fields.language.en-GB',
  [MaintainedLanguage.FrenchBelgium]: 'form:fields.language.fr-BE',
  [MaintainedLanguage.FrenchFrance]: 'form:fields.language.fr-FR',
  [MaintainedLanguage.German]: 'form:fields.language.de-DE',
  [MaintainedLanguage.GermanSwitzerland]: 'form:fields.language.de-CH',
  [MaintainedLanguage.Spanish]: 'form:fields.language.es-ES',
  [MaintainedLanguage.Italian]: 'form:fields.language.it-IT',
  [MaintainedLanguage.DutchNetherlands]: 'form:fields.language.nl-NL',
};
